import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../../types';
import {
  getAllLogsByDeviceAsync,
  getAllLogsCountByDeviceAsync,
} from '../../index';

export const useGetAllLogsByDeviceAsync = (
  deviceId: number,
  pagination: IPaginationParams,
) =>
  useQuery([`eventLogs${pagination.pageNumber}${deviceId}`, pagination], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    enabled: deviceId !== 0,
    queryFn: () => getAllLogsByDeviceAsync(deviceId, pagination),
  });

export const useGetAllLogsByDeviceCountAsync = (
  deviceId: number,
  pagination: IPaginationParams,
) =>
  useQuery([`eventLogsCount${pagination.pageNumber}${deviceId}`, pagination], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    enabled: deviceId != 0,
    queryFn: () => getAllLogsCountByDeviceAsync(deviceId),
  });
